import hasOwnProperty_1 from './has-own-property.js';

var hasOwn = hasOwnProperty_1;

var isDataDescriptor = function (descriptor) {
  return descriptor !== undefined && (hasOwn(descriptor, 'value') || hasOwn(descriptor, 'writable'));
};

export { isDataDescriptor as default };
